<template>
    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Date and time</th>
                    <th>Delay</th>
                    <th>Type</th>
                    <th>JA Agent</th>
                    <th>Call length</th>
                    <th>Disposition</th>
                    <th>Employer</th>
                    <th>Text</th>
                    <th>Notes</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(f, index) in deja" :key="index">
                    <td>{{ f.date_formatted }}</td>
                    <td>{{ f.delay }}</td>
                    <td>{{ f.contact_type }}</td>
                    <td>{{ f.agent_name }}</td>
                    <td>{{ f.call_length }}</td>
                    <td>{{ f.call_disposition }}</td>
                    <td>{{ f.employer_name }}</td>
                    <td>{{ f.sms_text }}</td>
                    <td>{{ f.note }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'deja',
    ],
}
</script>